import React, { Component } from 'react'
// import variables from '../_mixins.scss'

import './grid.scss'

class Grid extends Component {
  constructor (props) {
    super(props)

    // this.gridRef = null
    // this.gridWidth = 0

    this.state = {
      cols: []
    }

    this.onClick = this.onClick.bind(this)
    // this.setRef = this.setRef.bind(this)
    // this.handleResize = this.handleResize.bind(this)
    // this.getGapSize = this.getGapSize.bind(this)
    // this.updateGridSize = this.updateGridSize.bind(this)
  }

  // componentDidMount () {
  //   window.addEventListener('resize', this.handleResize, this)

  //   this.updateGridSize()
  // }

  // componentWillUnmount () {
  //   window.removeEventListener('resize', this.handleResize, this)
  // }

  // setRef (node) {
  //   this.gridRef = node
  // }

  // handleResize () {
  //   if (this.gridWidth !== this.gridRef.offsetWidth) {
  //     console.log('resizing grid', this.gridWidth)
  //     this.updateGridSize()
  //   }
  // }

  // getGapSize () {
  //   const { gap } = this.props

  //   return parseInt(Object.values(variables)[gap - 1], 10)
  // }

  // updateGridSize () {
  //   if (this.gridRef) {
  //     const columns = this.props.cols
  //     const gap = this.getGapSize()
  //     const childrenCount = this.props.children.length === undefined ? 0 : this.props.children.length

  //     this.gridWidth = this.gridRef.offsetWidth

  //     let lengthDiff = 0
  //     if (childrenCount > columns.length) {
  //       lengthDiff = childrenCount - columns.length
  //     }
  //     let sum = lengthDiff
  //     for (let i = 0; i < columns.length; i++) {
  //       sum += columns[i]
  //     }

  //     const avgLength = this.gridWidth / sum

  //     // Find the nearest on the lower side to the avgLength
  //     // Example: if avg is 15 and variables is [8, 16, 24] it returns 8
  //     const scales = Object.values(variables)
  //     let colWidth = 0
  //     for (let i = 0; i < scales.length; i++) {
  //       const currentInt = parseInt(scales[i])
  //       if ((currentInt + gap) < avgLength) {
  //         colWidth = currentInt
  //       }
  //     }

  //     console.log('VARIABLES', { sum, avgLength, colWidth, width: this.gridWidth, childrenCount, gap })

  //     // let gridColumns = []
  //     // for (let i = 0; i < columns.length; i++) {
  //     //   gridColumns.push(columns[i] * colWidth)
  //     // }
  //     // if (lengthDiff > 0) {
  //     //   // Add columns for rest of children
  //     //   for (let i = 0; i < lengthDiff; i++) {
  //     //     gridColumns.push(colWidth)
  //     //   }
  //     // }
  //     let gridColumns = ''
  //     for (let i = 0; i < columns.length; i++) {
  //       gridColumns += (columns[i] * colWidth) + 'px '
  //     }
  //     if (lengthDiff > 0) {
  //       // Add columns for rest of children
  //       for (let i = 0; i < lengthDiff; i++) {
  //         gridColumns += colWidth + 'px '
  //       }
  //     }

  //     this.gridRef.style.gridTemplateColumns = gridColumns
  //     this.gridRef.style.gridGap = gap + 'px'
  //     // this.setState({
  //     //   cols: gridColumns
  //     // }, () => console.timeEnd('updateGridSize' + rnd))
  //   }
  // }

  onClick (e) {
    if (this.props.onClick !== null) {
      this.props.onClick(e)
    }
  }

  getChildCount (children) {
    if (children.length === undefined) {
      return 0
    }

    return children.reduce((sum, child) => {
      if (!child) return sum

      if (Array.isArray(child)) {
        return sum + child.length
      }

      return sum + 1
    }, 0)
  }

  getGridColumns () {
    const { cols, children } = this.props
    if (typeof cols === 'string') return cols

    const childrenCount = React.Children.toArray(children).length // this.getChildCount(children)

    const columns = cols.reduce((prev, col) => {
      if (Array.isArray(col)) {
        // [3, 2] => repeat(3, 2fr)
        return {
          length: prev.length + col[0],
          cols: prev.cols + ` repeat(${col[0]}, ${col[1]}fr)`
        }
      }

      let newCol = ` ${col}fr`
      if (typeof col === 'string') {
        newCol = ` ${col}`
      }

      return {
        length: prev.length + 1,
        cols: (prev.cols + newCol).trim()
      }
    }, { length: 0, cols: '' })

    let extraColsCount = 0
    if (childrenCount > columns.length) {
      extraColsCount = childrenCount - columns.length
    }

    // const definedCols = columns.length > 0 ? columns.join('fr ') + 'fr' : ''
    const columnUnit = this.props.evenColumns ? 'minmax(0, 1fr)' : '1fr'
    const extraCols = extraColsCount > 0 ? ` repeat(${extraColsCount}, ${columnUnit})` : ''

    const gridTemplateColumns = columns.cols + extraCols
    // console.log('[GTC]', { gridTemplateColumns, cols: columns.length, children: childrenCount })
    return gridTemplateColumns
  }

  getGridStyle () {
    const { justify, align } = this.props
    const validValues = [ 'start', 'center', 'end' ]

    let style = ''
    if (validValues.includes(justify)) {
      style += ` justify-${justify}`
    }
    if (validValues.includes(align)) {
      style += ` align-${align}`
    }

    return style
  }

  getRowSpanClass () {
    if (this.props.rowSpan) {
      return ' rs-' + this.props.rowSpan
    }

    return ''
  }

  getSpacingClass () {
    switch (this.props.spacing) {
      case undefined:
      case null:
      case 0:
        return ''
    }
    return ' pg-mb-' + this.props.spacing
  }

  getStyle () {
    let extraClass = ''
    if (this.props.className) {
      extraClass += ` ${this.props.className}`
    }
    if (this.props.nogap) {
      extraClass += ' no-grid-gap'
    }

    return 'element-grid' + this.getGridStyle() + this.getRowSpanClass() + this.getSpacingClass() + extraClass
  }

  render () {
    if (!this.props.children) return null
    // const gridStyle = {
    //   gridTemplateColumns: this.state.cols.reduce((columnStr, col) => `${columnStr}${col}px `, ''),
    //   gridGap: this.getGapSize()
    // }

    return (
      <div
        // ref={this.setRef}
        className={this.getStyle()}
        style={{ gridTemplateColumns: this.getGridColumns() }}
        onClick={this.onClick}
        // style={gridStyle}
      >
        {this.props.children}
      </div>
    )
  }
}

Grid.defaultProps = {
  cols: [],
  rowSpan: null,
  gap: 1,
  className: '',
  justify: null, // [ 'start', 'center', 'end' ]
  align: null, // [ 'start', 'center', 'end' ]
  spacing: 0,
  onClick: null,
  nogap: false,
  evenColumns: false
}

export default Grid



// WEBPACK FOOTER //
// ./src/app/shared/elements/grid/index.js